<style lang="less" scoped>
.individualList {
    width: 100%;
    min-height: 100%;
    background-color: #f0f2f6;
    .list {
        margin-top: 20px;
        width: 100%;
        // height: 612px;
        background-color: #fff;
        padding: 20px;
        padding-top: 0px;
        box-sizing: border-box;
        text-align: left;
        .header {
            // width: 100%;
            // height: 16px;
            color: rgba(18, 18, 18, 1);
            font-size: 28px;
            // margin-bottom: 18px;
            width: 100%;
            height: 104px;
            line-height: 104px;
        }
        .content {
            width: 100%;
            color: rgba(162, 157, 157, 1);
            font-size: 22px;
            margin-bottom: 16px;
            .item {
                width: 100%;
                height: 40px;
                line-height: 40px;
            }
        }
        .footer {
            width: 100%;
            text-align: right;
            .button {
                display: inline-block;
                width:180px;
                height:60px;
                line-height: 60px;
                text-align: center;
                border-radius: 15px;
                text-align: center;
                border: 1px solid rgba(187, 187, 187, 1);
                background:rgba(33,170,255,1);
                border-radius:10px;
                font-size:20px;
                font-family:Microsoft YaHei;
                font-weight:400;
                color:rgba(255,255,255,1);
            }
        }
    }
}
</style>

<template>
  <div class="individualList">
      <nut-infiniteloading 
        @loadmore="onInfinite" 
        :is-show-mod="true" 
        :has-more="isHasMore" 
        :is-loading="isLoading" 
        :threshold="200"
      >
      <div class="list" v-for="(item,key) in individualArr" :key="key">
          <div class="header">{{item.name}}</div>
          <div class="content">
              <div class="item">统一社会信用代码：{{item.credit_code}}</div>
              <div class="item">经营者：{{item.legal_name}}</div>
          </div>
          <div class="footer">
              <div class="button" @click="details(item.id)">查看详情</div>
          </div>
      </div>
      </nut-infiniteloading>
  </div>
</template>

<script>
import http from '../../api/index.js'
import config from "../../utils/config.js";

export default {
  data() {
    return {
        individualArr:[],
        page: 1,
        count: 0,
        isHasMore: true,
        isLoading: false,
        isErr: false
    }
  },
  mounted() {
      this.individualArr = [];
      this.saasorderbusinessmenPagePost()
  },
  methods: {
    onInfinite () {
        this.isLoading = true;
        if (this.page <= this.count/10) {
            this.page = this.page + 1;
            this.saasorderbusinessmenPagePost()
        } else {
            this.isHasMore = false;
            this.isLoading = false;
        }
    },
    saasorderbusinessmenPagePost() {
        http.post(config.saasorderbusinessmenPage, {
            currentPage: this.page,
            pageSize: 10
        }).then(e => {
            console.log(e,'个体户')
            if (e.code == 1) {
                this.count = e.data.count
                for (let i = 0; i < e.data.rows.length; i++) {
                   this.individualArr.push(e.data.rows[i]) 
                }
                // this.individualArr = e.data.rows
            }
            this.isLoading = false;
        });
    },
    details(id) {
        let url = "/individualDetails";
        this.$router.push({ path: url , query: { id: id }});
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/individualList/index.vue